import React from 'react';

export interface LinkedInProps {
  className?: string;
}

const LinkedIn: React.FC<LinkedInProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 13 12" fill="none" className={className}>
      <path
        d="M3.18719 12.0041H0.698496V3.98963H3.18719V12.0041ZM1.94134 2.89641C1.14565 2.89641 0.5 2.23704 0.5 1.44134C0.5 0.645647 1.14522 0 1.94134 0C2.73747 0 3.38269 0.645218 3.38269 1.44134C3.38269 2.23704 2.73704 2.89641 1.94134 2.89641ZM12.5015 12.0041H10.0184V8.10274C10.0184 7.17285 9.9995 5.98059 8.72449 5.98059C7.43063 5.98059 7.23213 6.99065 7.23213 8.03586V12.0041H4.74601V3.98963H7.13267V5.08286H7.1674C7.49965 4.45308 8.31121 3.78857 9.52191 3.78857C12.0406 3.78857 12.5036 5.44727 12.5036 7.60157V12.0041H12.5015Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkedIn;
